import { useTexture } from "@react-three/drei";
import { useEffect, useMemo } from "react";
import { Color, FrontSide, MeshMatcapMaterial, MeshStandardMaterial } from "three";

import matCapUrl from "./textures/matcap_chrome_blurred.png";
import { useEnergyMaterial } from "./materials/EnergyMaterial/EnergyMaterial";
import { FresnelMaterialImpl } from "./materials/FresnelMaterial";

export const createPodestMaterial = () => {
  var mat = new MeshStandardMaterial();
  // mat.color = new Color("#052112");
  mat.color = new Color("#082e1a");
  mat.metalness = 0.9;
  mat.roughness = 0.4;

  return mat;
};

export const useChromeMaterial = () => {
  // const [matCapTexture] = useMatcapTexture("3B3C3F_DAD9D5_929290_ABACA8", 256);
  const matCapTexture = useTexture(matCapUrl);

  const chromeMaterial = useMemo(() => {
    var mat = new MeshMatcapMaterial();
    mat.matcap = matCapTexture;
    mat.color = new Color("#b6cabf");

    return mat;
  }, []);

  return chromeMaterial;
};

export const useRemapMaterials = (model) => {
  const chromeMat = useChromeMaterial();
  const energyMaterial = useEnergyMaterial();

  const fresnelMaterial = useMemo(() => {
    const mat = new FresnelMaterialImpl();
    mat.transparent = true;
    mat.depthWrite = true;
    mat.opacity = 0.5;
    mat.uniforms.uBaseColor.value = new Color("#082e1a");
    mat.uniforms.uFresnelColor.value = new Color("#ffffff");
    mat.uniforms.uFresnelPower.value = 3;
    mat.side = FrontSide;

    return mat;
  }, []);

  const createFresnelMaterial = (originMat) => {
    const mat = new FresnelMaterialImpl();
    mat.transparent = true;
    mat.depthWrite = true;
    mat.opacity = 0.65;
    mat.uniforms.uBaseColor.value = originMat.color;
    mat.uniforms.uFresnelColor.value = new Color("#ffffff");
    mat.uniforms.uFresnelPower.value = 3;
    mat.side = FrontSide;

    return mat;
  };

  useEffect(() => {
    if (model) {
      model.traverse((c) => {
        if (c.type == "Mesh") {
          if (c.material.name.startsWith("MA_DefaultContent")) {
            c.material = chromeMat;
          } else if (c.material.name.startsWith("MA_Kachel")) {
            c.material = createPodestMaterial();
          } else if (c.material.name.startsWith("MA_Fresnel")) {
            c.renderOrder = 2;
            if (c.material.name.includes("_battery")) {
              c.renderOrder = 1;
            }
            c.material = createFresnelMaterial(c.material);
          } else if (c.material.name.startsWith("MA_Induc_GreenCable") || c.material.name.startsWith("MA_Energy")) {
            c.material = energyMaterial;
            c.renderOrder = 1;
          }
        }
      });
    }
  }, [model]);

  return null;
};
